import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Box, Flex, Button } from "rebass";
import { graphql } from "gatsby";
import TweetEmbed from "react-tweet-embed";
import { Examples, FeatureList, TableOfContents } from '../components/Blocks/';
import { AboutMeFeatures, Banner, Container, CopyBlock, EmailSignup, Grid, JumpToCourse, LazyImage, LinkImage, NavGrid, Pricing, Testimonial, Title, Video } from "@swizec/gatsby-theme-course-platform";
import pshot2 from "../images/pshot2.gif";
export const pageQuery = graphql`
  query {
    Test2: file(relativePath: { eq: "Test2.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 300, maxHeight: 300) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Test3: file(relativePath: { eq: "Test3.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 300, maxHeight: 300) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Test6: file(relativePath: { eq: "Test6.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 300, maxHeight: 300) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    PerWiklander: file(relativePath: { eq: "perwiklander.jpeg" }) {
      childImageSharp {
        fluid(maxWidth: 300, maxHeight: 300) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Test5: file(relativePath: { eq: "Test5.png" }) {
      childImageSharp {
        fluid(maxWidth: 300, maxHeight: 300) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Test8: file(relativePath: { eq: "Test8.png" }) {
      childImageSharp {
        fluid(maxWidth: 300, maxHeight: 300) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    swizec: file(relativePath: { eq: "me-circle.png" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid
          presentationWidth
        }
      }
    }
  }
`;
export const _frontmatter = {};
const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Title h1 mdxType="Title">
  # Stop copy pasting D3 examples, create data visualizations of your own
    </Title>
    <Container width={[1, 1, 1 / 2]} mt={[-0.5, -1, -1]} mb={[4, 4, 5]} sx={{
      textAlign: 'center'
    }} mdxType="Container">
      <p>{`Learn how to `}<strong parentName="p">{`build scalable dataviz components`}</strong>{` your whole team can understand with React for Data Visualization - `}<strong parentName="p"><em parentName="strong">{`updated for 2020`}</em></strong></p>
      <Video id="CoTTJ-vR1Mc" mdxType="Video" />
      <p>{`So you want to build a beautiful data viz. You've got data burning a hole through your pocket, an idea for a juicy story, and your boss or client are waiting for results.`}</p>
      <p>{`You want something that looks great, works in the browser, performs on mobile, lets users interact with their data, syncs across an entire dashboard, and works as building blocks for future projects.`}</p>
      <p>{`Cool ... now what?`}</p>
      <JumpToCourse to="#pricing" style={{
        marginTop: "15px"
      }} mdxType="JumpToCourse" />
      <p>{`I remember building my first data visualization back in 2012. Visualized my coding habits from GitHub data.`}</p>
    </Container>
    <Container width={[1, 3 / 4, 3 / 4]} mdxType="Container">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/fe0bc09ecba2be12c7b828b8e01da009/dc333/scatterplot-finished.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "33.18385650224215%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'133\\'%20viewBox=\\'0%200%20400%20133\\'%20preserveAspectRatio=\\'none\\'/%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/fe0bc09ecba2be12c7b828b8e01da009/ca0a1/scatterplot-finished.webp 223w", "/static/fe0bc09ecba2be12c7b828b8e01da009/75680/scatterplot-finished.webp 445w", "/static/fe0bc09ecba2be12c7b828b8e01da009/8d1ba/scatterplot-finished.webp 890w", "/static/fe0bc09ecba2be12c7b828b8e01da009/e5056/scatterplot-finished.webp 938w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/fe0bc09ecba2be12c7b828b8e01da009/e92b6/scatterplot-finished.png 223w", "/static/fe0bc09ecba2be12c7b828b8e01da009/e66bf/scatterplot-finished.png 445w", "/static/fe0bc09ecba2be12c7b828b8e01da009/4ef49/scatterplot-finished.png 890w", "/static/fe0bc09ecba2be12c7b828b8e01da009/dc333/scatterplot-finished.png 938w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
        `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/fe0bc09ecba2be12c7b828b8e01da009/4ef49/scatterplot-finished.png",
                "alt": "scatterplot finished",
                "title": "scatterplot finished",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
      `}</picture>{`
  `}</a>{`
    `}</span></p>
    </Container>
    <Container width={[1, 3 / 4, 1 / 2]} mdxType="Container">
      <p>{`I was so proud! Only took me a week. `}<span role="img" aria-label="strong arm">{`💪`}</span></p>
    </Container>
    <Title h2 mdxType="Title">
## &quot;I've tried D3 in the past, found it powerful but a bit confusing to use&quot;
    </Title>
    <Container width={[1, 3 / 4, 1 / 2]} mdxType="Container">
      <p>{`Dynamic data visualization for the web is a pain in the ass you see.
Harder than it looks.`}</p>
      <p>{`Yeah sure anyone can build a chart in google docs but that's not what you're after is it? You can't build a product on top of google sheets. You definitely can't feed in dynamic data from an API, personalized to the user, and let them navigate and explore.`}</p>
      <p>{`You've heard people build these amazing things with D3. The New York Times uses it, The Guardian does, so do Netflix, Uber, 23andMe, Visa, Walmart, and many others. I know because they've been to my workshops ;)`}</p>
      <p>{`You hunt the web for examples and omaigod what is this!? How the hell is D3 doing that? `}<span role="img" aria-label="oO">{`😳`}</span>{`😳`}</p>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "600px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/25d2bde8baf1d9e55bed9a13713a2b40/0a47e/spaghettiImg.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "106.27802690582959%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'425\\'%20viewBox=\\'0%200%20400%20425\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M88%2054h-2c-1-2-3%200-3%203%201%202%204%203%204%201h-1l-1-1h3l6%202c5%200%206-1%206-2%200-2%200-2%201%200%200%202%201%202%201%201h2c1%202%204%200%204-3s-1-4-3-1h-8c-1-2-3-1-3%201l-1%201v-2l-3-2c-1%200-2%200-2%202M54%20195h-5c-1%202-1%202-3%200H36c-1-3-4%200-4%203s1%204%203%201h2c0%202%201%202%204%200h5l-1-1v-1l3%202c1%201%201%201%201-1s0-2%201-1l2%202h1c1%203%204%200%204-3s-1-4-3-1m0%2047h-2c-2-2-4-1-4%201l-1-1H36c-1-3-4%200-4%203s1%204%203%201h2c0%202%201%202%204%200h5l-1-1v-1l3%202%201-1%201-1%201%202h2c1%203%204%200%204-3s-1-4-3-1m45%20113H82l-2-1c-2%200-2%201-2%204s0%203%202%202l2-2c1-1%201%200%201%201%200%202%201%203%203%200h4l2%201-1-2v-1l2%201c0%202%202%201%202-1%201-2%201-2%201%200l1%202h3c1%202%203%200%203-3s-1-4-4-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/25d2bde8baf1d9e55bed9a13713a2b40/ca0a1/spaghettiImg.webp 223w", "/static/25d2bde8baf1d9e55bed9a13713a2b40/75680/spaghettiImg.webp 445w", "/static/25d2bde8baf1d9e55bed9a13713a2b40/e88ff/spaghettiImg.webp 600w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/webp"
              }}></source>{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/25d2bde8baf1d9e55bed9a13713a2b40/e92b6/spaghettiImg.png 223w", "/static/25d2bde8baf1d9e55bed9a13713a2b40/e66bf/spaghettiImg.png 445w", "/static/25d2bde8baf1d9e55bed9a13713a2b40/0a47e/spaghettiImg.png 600w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/png"
              }}></source>{`
        `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/25d2bde8baf1d9e55bed9a13713a2b40/0a47e/spaghettiImg.png",
                "alt": "spaghettiImg",
                "title": "spaghettiImg",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
      `}</picture>{`
  `}</a>{`
    `}</span></p>
      <p>{`That's a bar chart by the way. You'd never guess just looking at the code. I've been doing this for years and I still have to simulate D3 examples in my mind to figure out how they work.`}</p>
      <p>{`You decide that's too much and look for a library. Something easy you can use to finish real quick.`}</p>
      <p>{`You find a bunch of libraries built on top of D3. Some even combine React and D3. Perfect for any modern web project!`}</p>
      <p>{`You cobble something together and call it a day. Job well done.`}</p>
      <LazyImage src="https://media.giphy.com/media/woZVO2B8ZQ55DqKsmN/giphy.gif" height={260} mdxType="LazyImage" />
      <JumpToCourse to="#pricing" style={{
        marginTop: "15px"
      }} mdxType="JumpToCourse" />
    </Container>
    <EmailSignup mdxType="EmailSignup" />
    <Title h2 mdxType="Title">
## Libraries are hard to customize
    </Title>
    <Container width={[1, 3 / 4, 1 / 2]} mdxType="Container">
      <p>{`Your boss takes one look and says `}<em parentName="p">{`"Ok but can you make it follow our style guide?"`}</em></p>
      <p>{`Errr ...`}</p>
      <p>{`Okay okay, some CSS, a little trickery, tweak the arguments and you got dis. Crisis averted!`}</p>
      <p><em parentName="p">{`"I don't like how this animation looks"`}</em></p>
      <p><em parentName="p">{`"Can we tweak that margin?"`}</em></p>
      <p><em parentName="p">{`"Make those bars taller"`}</em></p>
      <p><em parentName="p">{`"Add a line chart and I want tooltips to show up on all 5 charts when I mouse over the same data point"`}</em></p>
      <p>{`Now you're in trouble buster.`}</p>
      <LazyImage src="https://media.giphy.com/media/IYIlvuWc21U4g/giphy.gif" height={260} mdxType="LazyImage" />
      <p>{`You used a library and those always break down when you start customizing stuff. At some point you spend more time fighting the library than building your data visualization.`}</p>
      <p>{`Time to learn D3.`}</p>
    </Container>
    <Title h2 mdxType="Title">
## &quot;There are way too many shitty resources on D3 floating around on the interwebs, and frankly, the D3 docs are shit too because they're WAY TOO COMPLICATED AND VERBOSE for someone that just wants to understand how it works and get shit done.&quot;
    </Title>
    <Container width={[1, 3 / 4, 1 / 2]} mdxType="Container">
      <p>{`You can do what everyone else does: Copy paste some examples that look like what you're building, make some tweaks, and hope for the best.`}</p>
      <p>{`You're not proud of your code and you're not quite sure how it works, but it works and that's what matters. Right?`}</p>
      <p>{`Yep that works until you have to change something. Or explain how it works to another engineer on your team so they can fix a bug.`}</p>
      <p>{`God forbid you come back 6 months later looking to fix a thing or add a feature. Time to re-study all of that code and figure out how it works.`}</p>
      <p>{`ugh`}</p>
      <Testimonial quote="I'm starting a new position where I will focus on data visualization using React and d3. I got everything I needed from the book, your examples were straight forward and easy to follow. Thanks!" image={props.data.Test3.childImageSharp.fluid.src} name="Aristides Staffieri" company="Engineer at ProtectWise" mdxType="Testimonial" />
    </Container>
    <CopyBlock mdxType="CopyBlock" />
    <Title h2 mdxType="Title">
  ## &quot;without it I'm stuck using stack overflow in a disjointed, incorrect
  mess&quot;
    </Title>
    <Container width={[1, 3 / 4, 1 / 2]} mdxType="Container">
      <LazyImage height={300} src={pshot2} mdxType="LazyImage" />
      <p>{`You can avoid all that and learn how to build scalable and reusable dataviz components your whole team and future you can understand with React for Data Visualization.`}</p>
      <p>{`Get the confidence you need to excel and build anything you can imagine. 💪`}</p>
      <p>{`React is the biggest revolution in JavaScript programming since jQuery hit the scene 10 years ago, and D3 is unlike anything you've seen before.`}</p>
      <p>{`The problem comes from how most of us first learn to code. "It's like a cooking recipe", teachers will say.`}</p>
      <p>{`Take a bell pepper and cut it up. Then sprinkle some salt and pepper, add olive oil, and voila: you have a refreshing salad. A very simple salad with a single ingredient, but a salad nonetheless. You can follow along and eventually you will understand what the code does.`}</p>
      <p>{`That's imperative programming. It reads as a series of steps. How to do something.`}</p>
      <p>{`React and D3 are declarative. You don't write How you want your code to work, you write What you want to achieve. Your bell pepper salad recipe looks more like this:`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`<Salad>
  <Oil />
  <BellPepper cut salted />
</Salad>
`}</code></pre>
      <p>{`You look at that and you know it's a salad. It involves oil and bell peppers. You don't have to read the steps to know the result. The recipe declares what it's making.`}</p>
      <p>{`Declarative code makes your project cleaner and easier to maintain. Means more time creating value for your users and clients.`}</p>
      <p>{`But learning how to think declaratively is hard. It starts like voodoo magic. We've all been there. It still hurts my brain sometimes.`}</p>
      <p>{`That's why `}<strong parentName="p">{`React for Data Visualization`}</strong>{` starts with small building blocks then builds up to entire dashboards. Learn the basics in about an hour, then dive as deep as you want`}</p>
      <JumpToCourse to="#pricing" style={{
        marginTop: "15px",
        margintBottom: "15px"
      }} mdxType="JumpToCourse" />
      <Testimonial quote="I use React because it is the sane way of doing things. I use D3 because I have to. I want nice interactive charts. I want to stay sane." image={props.data.PerWiklander.childImageSharp.fluid.src} name="Per" company="Frontend Consultant" mdxType="Testimonial" />
    </Container>
    <Title h2 mdxType="Title">
## Why use React and D3 for data visualization
    </Title>
    <Container width={[1, 3 / 4, 1 / 2]} mdxType="Container">
      <p>{`I believe React combined with D3 is the best thing that's ever happened to data visualization on the web.`}</p>
      <p>{`React's approach to components makes your code more reusable, its advanced algorithms make it fast, and D3 has the best tools for dataviz. Together they represent two of the most popular JavaScript libraries on the web.`}</p>
      <p>{`Watch some of my conference talks for a sneak peek 👇`}</p>
      <Video id="UP1nCXG2t4M" mdxType="Video" />
      <p>{`The talk shows a proof of concept approach to making fancy animations with React and d3js - a Space Invaders game. I explain the basic approach, where I got the idea, and show off some code.`}</p>
      <Video id="47uMw-2mb4U" mdxType="Video" />
      <p>{`This talk is more hands on. I show how the animated alphabet, particle generator, and talk about the benefits of componentization when it comes to building modern data visualization.`}</p>
      <Video id="9JvIyz7uB2s" mdxType="Video" />
      <p>{`You don't have to watch the whole talk, it's all in React for Data Visualization.`}</p>
      <Video id="Bdeu-BFisJU" mdxType="Video" />
      <p>{`A Learn with Jason episode where in just an hour we built an animated scatterplot from scratch and proved React-based D3 visualization works great with Gatsby. The dataviz rendered statically at build time.`}</p>
    </Container>
    <Title h2 mdxType="Title">
## React for Data Visualization is designed for busy people like you
    </Title>
    <Container width={[1, 3 / 4, 1 / 2]} mdxType="Container">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/d0df536906a2588d0eb64122a0db650e/30c0b/pshot3.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'216\\'%20viewBox=\\'0%200%20400%20216\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M11%2023l-1%2013c0%2011%200%2012%202%2012s2-1%202-5c0-8%204-8%205%200%200%204%201%205%202%205%202%200%202-1%201-5l-1-7v-1c2-2%201-11-1-12h-9m14%2012v13h6c4%200%205%200%205-2s-1-2-3-2c-4%200-4%200-4-3%200-4%200-4%203-4%202%200%203%200%203-2s-1-2-3-2c-3%200-3%200-3-3%200-4%200-4%204-4%202%200%203%200%203-2s-1-2-5-2h-6v13m17-12l-2%2012c-2%2014-2%2013%200%2013l2-2c1-4%205-4%206-1%201%204%204%204%204%200l-4-22-3-1-3%201m14%201c-2%202-3%2021-1%2023%204%204%2012-1%2011-6-1-4-3-3-4%201l-2%203c-1%200-2-2-2-10s0-9%202-9c1%200%202%201%202%203l2%202c2%200%203-4%200-7-1-2-6-3-8%200m11%200l2%202c3%200%203%200%202%2011%200%2010%200%2011%202%2011s2-1%202-11V26h3l2-2c0-2-1-2-6-2-6%200-7%200-7%202m40%200c-3%203-3%205%200%208l3%202h22c25%200%2027%200%2027-6s-1-6-27-6c-22%200-23%200-25%202M11%2061v9h8v-8c0-8-1-10-5-10h-3v9m12-8l-1%209c-2%207-2%208%200%208l1-1%202-2%202%202%202%201%201-3-2-7c0-7-1-8-3-8l-2%201m19%200l-2%208c-1%208-1%2011%201%208%201-2%204-3%204%200l2%201%201-2c0-10-4-19-6-15m11%200v1l1%209c1%206%201%207%203%207s3-1%204-7V52l-3%207-1%206v-7c-1-5-2-7-4-5m321%200l-1%204v3h7c7%200%207-1%207-3v-4c-1-1-12-2-13%200m-1%2015v4h14v-8h-14v4m0%2012l1%204h13v-8h-14v4m1%208l-1%204v3h14v-7l-7-1-6%201M24%2093l-1%204-1%203v1c3%200%204%206%201%206s-4-3-3-5v-1c-3%201-2%205%200%207%202%201%203%202%203%204%201%204%204%205%206%203%201-1%200-1-2-1-3%201-4-2-2-4%201-1%205%201%205%203s3%201%203-1c1-2%205-3%206-1s-1%204-4%204h-1c2%202%205%201%206-3l1-4v-1c-2%200-3-2-2-4l2-2v-1l-1-4c-1-4-4-5-7-3-1%202-2%202-2%201l-2-1v2c2%201%200%204-3%204s-3-5%200-6c2-1%202-1%200-1l-2%201m24%202c0%202%201%202%203%202l4%202c4%204%201%2011-4%2011-2%200-3%203-2%204%202%202%209-1%2011-5%205-7-1-17-9-17-3%200-3%200-3%203m12-1c1%202%203%203%205%203%203%201%204%203%201%204-3%200-3%205%200%205%203%201%202%203-1%204-2%200-4%201-4%203l-2%202h4c8%200%2010-2%209-11l1-4c1-5-3-8-10-8h-5l2%202m313%209v4h14v-8h-14v4m0%2023v4h14v-8h-14v4M0%20130v5h90v-11H0v6m373%2034v4h14v-8h-14v4m0%2012l1%204h13v-8h-14v4m1%208l-1%204v3h14v-7l-7-1-6%201m-1%2015v4h14v-8h-14v4m0%2012l1%204h13v-8h-14v4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/d0df536906a2588d0eb64122a0db650e/ca0a1/pshot3.webp 223w", "/static/d0df536906a2588d0eb64122a0db650e/75680/pshot3.webp 445w", "/static/d0df536906a2588d0eb64122a0db650e/8d1ba/pshot3.webp 890w", "/static/d0df536906a2588d0eb64122a0db650e/3838e/pshot3.webp 1335w", "/static/d0df536906a2588d0eb64122a0db650e/e11e5/pshot3.webp 1780w", "/static/d0df536906a2588d0eb64122a0db650e/2f7d6/pshot3.webp 2956w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/d0df536906a2588d0eb64122a0db650e/e92b6/pshot3.png 223w", "/static/d0df536906a2588d0eb64122a0db650e/e66bf/pshot3.png 445w", "/static/d0df536906a2588d0eb64122a0db650e/4ef49/pshot3.png 890w", "/static/d0df536906a2588d0eb64122a0db650e/4e814/pshot3.png 1335w", "/static/d0df536906a2588d0eb64122a0db650e/701e9/pshot3.png 1780w", "/static/d0df536906a2588d0eb64122a0db650e/30c0b/pshot3.png 2956w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
        `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d0df536906a2588d0eb64122a0db650e/4ef49/pshot3.png",
                "alt": "pshot3",
                "title": "pshot3",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
      `}</picture>{`
  `}</a>{`
    `}</span></p>
      <p>{`React for Data Visualization gives you a `}<strong parentName="p">{`quick overview of the basics`}</strong>{` to get you started, followed by a `}<strong parentName="p">{`deep dive`}</strong>{` that `}<strong parentName="p">{`solidifies your knowledge`}</strong>{` through varied projects and examples. `}<strong parentName="p">{`Build working code`}</strong>{` that you can `}<strong parentName="p">{`show off to your friends, boss, and coworkers.`}</strong></p>
      <p>{`Learn the basics with `}<strong parentName="p">{`interactive examples right in your browser`}</strong>{` — no need to install anything. Forget about Npm and Webpack and Babel and Node. `}<strong parentName="p">{`Just React and D3.`}</strong></p>
      <p><strong parentName="p">{`Dive into complex projects`}</strong>{` that teach you how it all fits together. Build `}<strong parentName="p">{`interactive visualizations`}</strong>{`, create `}<strong parentName="p">{`animations`}</strong>{`, and build `}<strong parentName="p">{`fast performance with canvas`}</strong>{`. Learn everything there is to know about building `}<strong parentName="p">{`beautiful apps with React and D3.`}</strong></p>
      <p>{`From the very `}<strong parentName="p">{`basics of React and D3`}</strong>{`, to state handling with `}<strong parentName="p">{`Redux`}</strong>{` and `}<strong parentName="p">{`MobX`}</strong>{`, React alternatives like `}<strong parentName="p">{`Preact`}</strong>{` and `}<strong parentName="p">{`Inferno.`}</strong></p>
      <p>{`And the best part?`}</p>
      <p>{`It's all cut into bite sized pieces. Whether you've got 5 minutes or an hour, you can get through this course. That's a promise.`}</p>
    </Container>
    <Title h2 mdxType="Title">
## Start with the building blocks
    </Title>
    <FeatureList mdxType="FeatureList" />
    <Container width={[1, 3 / 4, 1 / 2]} mdxType="Container">
      <Testimonial quote="The examples in V4 are off the hook. No wonder its been so much work, you have really extended the learning process into fun, interactive projects. I was specifically trying to learn topojson an map visualizations! What a breeze!" image={props.data.Test5.childImageSharp.fluid.src} name="Julio Gudiño" company="Frontend Developer" mdxType="Testimonial" />
    </Container>
    <Title h2 mdxType="Title">
## React for Data Visualization builds on practical examples
    </Title>
    <Container width={[1, 3 / 4, 1 / 2]} mdxType="Container">
      <Examples mdxType="Examples" />
      <JumpToCourse to="#pricing" style={{
        marginTop: "15px"
      }} mdxType="JumpToCourse" />
      <TableOfContents mdxType="TableOfContents" />
    </Container>
    <Pricing mdxType="Pricing" />
    <EmailSignup mdxType="EmailSignup" />
    <Container width={[1, 3 / 4, 1 / 2]} mdxType="Container">
      <Testimonial quote="I love having practical examples to help me learn new things faster. D3's docs alone are okay but marrying them with React (as a react newbie) is not as straightforward as someone handholding you through the process. And, since I don't have hours after work or on weekends to hack on things like I used to before I was married (or had kids), I need to optimize my learning." image={props.data.Test6.childImageSharp.fluid.src} name="Paulo Elias" company="Self Taught Developer" mdxType="Testimonial" />
    </Container>
    <Title h2 mdxType="Title">
## About the Author
    </Title>
    <Container width={[1, 3 / 4, 1 / 2]} mdxType="Container">
      <LinkImage link="https://swizec.com" image={props.data.swizec.childImageSharp} mdxType="LinkImage" />
      <p>{`Hi, I’m `}<strong parentName="p">{`Swizec Teller`}</strong>{`. I help `}<strong parentName="p">{`coders become software engineers.`}</strong></p>
      <p>{`Story time 👇`}</p>
      <p>{`React+D3 started as a bet in April 2015. A friend wanted to learn React and challenged me to publish a book. A month later React+D3 launched with 79 pages of hard earned knowledge.`}</p>
      <p>{`In April 2016 it became `}<strong parentName="p">{`React+D3`}</strong>{` ES6. 117 pages and growing beyond a single big project it was a huge success. I kept going, started live streaming, and publishing videos on YouTube.`}</p>
      <p>{`In 2017, after 10 months of work, `}<strong parentName="p">{`React + D3v4`}</strong>{` became the best book I'd ever written. At 249 pages, many examples, and code to play with it was designed like a step-by-step course. But I felt something was missing.`}</p>
      <p>{`So in late 2018 I rebuilt the entire thing as `}<img parentName="p" {...{
          "src": "https://reactfordataviz.com",
          "alt": "React for Data Visualization"
        }}></img>{` — a proper video course. Designed for busy people with real lives like you. Over 8 hours of video material, split into chunks no longer than 5 minutes, a bunch of new chapters, and techniques I discovered along the way.`}</p>
      <p><strong parentName="p">{`React for Data Visualization`}</strong>{` is the best way to learn how to build scalable dataviz components your whole team can understand.`}</p>
      <p>{`Some of my work has been featured in 👇`}</p>
      <AboutMeFeatures mdxType="AboutMeFeatures" />
    </Container>
    <CopyBlock mdxType="CopyBlock" />
    <Container width={[1, 3 / 4, 1 / 2]} mdxType="Container">
      <Testimonial quote="A sharply written work that delivers technical information in a conversational and easy to digest manner." image={props.data.Test8.childImageSharp.fluid.src} name="Malcolm Maclean" company="Author of D3 Tips & Tricks" mdxType="Testimonial" />
    </Container>
    <Pricing mdxType="Pricing" />
    <Title h1 mdxType="Title">
# FAQ - Frequently asked Questions
    </Title>
    <Container width={[1, 3 / 4, 1 / 2]} mdxType="Container">
      <h2 {...{
        "id": "react-for-dataviz-really-what-about-vue-svelte"
      }}>{`React, for dataviz, really? What about Vue? Svelte?`}</h2>
      <p>{`Yes, really. React is a fantastic tool for anything on the web. The ability to get in there and get your hands dirty, treat chunks of HTML as pure data, and have direct control over rendering is unprecedented.`}</p>
      <p>{`And nothing better's come around since. I've tried Vue, Svelte, (old) Angular, and a bunch of other frameworks. React still sparks the most joy.`}</p>
      <p>{`Your best bet to build reusable components your whole team can understand.`}</p>
      <h2 {...{
        "id": "cant-i-just-use-a-library"
      }}>{`Can't I just use a library?`}</h2>
      <p>{`Yes! Libraries are fantastic.`}</p>
      <p>{`I used Victory.js the other day (based on React and D3) and it was lovely. Made a basic chart in 5 minutes. 😍`}</p>
      <p>{`Then I couldn't figure out how to resize the damn thing so it wouldn't fill the whole screen. An hour I wasted on that. AN HOUR. Never figured it out.`}</p>
      <p>{`So now I have a chart that fills the whole screen and looks weird on desktop.`}</p>
      <p>{`That's the problem with libraries. Easy to get started, crazy hard to customize. God help you, if you want to step off the beaten path.`}</p>
      <p><a parentName="p" {...{
          "href": "https://reactfordataviz.com"
        }}>{`React for Dataviz`}</a>{` walks you through the basics of some popular libraries and their tradeoffs, if that fits your needs. Main goal is to teach you how to go custom 🤘`}</p>
      <h2 {...{
        "id": "do-i-need-to-be-a-react-expert-javascript-expert-d3-expert"
      }}>{`Do I need to be a React expert? JavaScript expert? D3 expert?`}</h2>
      <p><a parentName="p" {...{
          "href": "https://reactfordataviz.com"
        }}>{`React for Dataviz`}</a>{` is designed for React beginners. It was originally a head-fake to learn React in a more interesting way :)`}</p>
      <p>{`You'll need to know JavaScript. RDV doesn't teach you that.`}</p>
      <p>{`You'll learn everything you need about D3. And we avoid the confusing parts you don't need when you're using React.`}</p>
      <h2 {...{
        "id": "what-if-i-hate-react-or-dont-use-it-at-work"
      }}>{`What if I hate React or don't use it at work?`}</h2>
      <p>{`No worries. The core ideas in RDV work with any framework. You can use the same approach with Vue, Angular, or Svelte. Only difference is the syntax for rendering.`}</p>
      <p>{`Like where in React you'd write some JSX, with Vue you'd write template stuff. Where React has hooks, Vue has getters.`}</p>
      <p>{`Maybe I'll throw in a bonus video or two 🤔`}</p>
      <h2 {...{
        "id": "im-not-from-usa-and-your-course-is-expensive-as-heck-can-i-get-a-discount"
      }}>{`I'm not from USA and your course is expensive as heck. Can I get a discount?`}</h2>
      <p><a parentName="p" {...{
          "href": "https://reactfordataviz.com"
        }}>{`React for Dataviz`}</a>{` uses location-based pricing. Adjusted for every country on the `}<a parentName="p" {...{
          "href": "https://en.wikipedia.org/wiki/Big_Mac_Index"
        }}>{`BigMac Index`}</a>{` based on your IP.`}</p>
      <p>{`If you don't see a regional discount and think you should, send me an email.`}</p>
      <h2 {...{
        "id": "what-if-i-dont-care-about-dataviz"
      }}>{`What if I don't care about dataviz?`}</h2>
      <p>{`Well that's a tough one. Do you care about having fun? About doing something creative with React? Want to stretch your mind, see what React can do that you never thought of before?`}</p>
      <p>{`Try `}<a parentName="p" {...{
          "href": "https://reactfordataviz.com"
        }}>{`React for Dataviz`}</a>{`. I think you'll like it.`}</p>
      <h2 {...{
        "id": "i-bought-some-version-of-reactd3-in-the-past-5-years-do-i-get-access-automatically"
      }}>{`I bought some version of React+D3 in the past 5 years. Do I get access automatically?`}</h2>
      <p>{`That depends.`}</p>
      <p>{`React+D3 went through several major rewrites. When it became a course in late 2018 / early 2019 was the last major change.`}</p>
      <p>{`The update for 2020 and changing focus to React Hooks is a significant update, but it's not a rewrite. If you accessed your current material through Teachable, you'll get access to the new stuff automatically. I'll be in touch.`}</p>
      <p><strong parentName="p">{`You have to purchase again to access the special workshop on Jun 25th`}</strong>{` ✌️`}</p>
      <h2 {...{
        "id": "i-cant-make-it-to-the-workshop-on-june-25th-should-i-still-purchase-reactfordataviz-or-can-i-wait"
      }}>{`I can't make it to the workshop on June 25th, should I still purchase ReactForDataviz or can I wait?`}</h2>
      <p>{`The workshop is special. Only for folks who buy now.`}</p>
      <p>{`You'll get the full recording after. It will not become part of the course itself.`}</p>
      <h2 {...{
        "id": "what-if-i-hate-your-course"
      }}>{`What if I hate your course?`}</h2>
      <p>{`30 day guarantee. Send an email, get a refund.`}</p>
      <p>{`Refund first, ask questions later. I like to know what bugged you and I don't make your answer a condition for refunding.`}</p>
      <h2 {...{
        "id": "cant-i-just-figure-this-out-myself-am-i-too-advanced"
      }}>{`Can't I just figure this out myself? Am I too advanced?`}</h2>
      <p>{`You definitely can! I did.`}</p>
      <p>{`My time tracker says I've spent 834 hours of my life on this material. Writing, researching, some marketing.`}</p>
      <p>{`How much is 834 hours worth to you? Even if you make just $10/hour like I did at my first web agency coding job, that's still $8,340.`}</p>
      <p>{`😉`}</p>
      <Testimonial quote="Great read with solid foundations to get you started crawling with react and up to a sprint!" image={props.data.Test2.childImageSharp.fluid.src} name="MΛHDI" company="Creator of Gyroscope" mdxType="Testimonial" />
    </Container>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      